import React, { Component } from 'react';
import BaseForm from './BaseForm';
import { TabPanel, Item } from 'devextreme-react/tab-panel';
import { LoadPanel } from 'devextreme-react/load-panel';
const initialState = {
	selectedIndex: 0,
	showLoadingPanel: false,
};
const position = { of: '#root' };
export default class CrudForm extends Component {
	state = { ...initialState };
	constructor(props) {
		super(props);
		this.tabPanel = React.createRef();
		this.loadingPanel = React.createRef();
		this.baseForm = React.createRef();
		this.setActiveTabIndex = this.setActiveTabIndex.bind(this);
		this.onSelectionChanged = this.onSelectionChanged.bind(this);
		this.onSelectionChanged = this.onSelectionChanged.bind(this);
		this.showLoadingPanel = this.showLoadingPanel.bind(this);
	}
	onSelectionChanged(args) {
		if (args.name === 'selectedIndex') {
			this.setState({
				selectedIndex: args.value,
			});
		}
	}
	showLoadingPanel(show) {
		this.baseForm.current.showLoadingPanel(show);
	}
	setActiveTabIndex(index) {
		this.setState({ selectedIndex: index });
	}
	render(props) {
		return (
			<React.Fragment>
				<LoadPanel
					shadingColor={'rgba(0,0,0,0.4)'}
					position={position}
					visible={this.state.showLoadingPanel}
					showIndicator={true}
					shading={true}
					showPane={false}
				/>
				<BaseForm {...this.props} ref={this.baseForm}>
					{this.props.outTabs}
					<div className="box box-default" id={'baseForm'}>
						<TabPanel selectedIndex={this.state.selectedIndex} onOptionChanged={this.onSelectionChanged}>
							<Item title={'Consulta'}>
								<div className="box-body">
									<div className="row">
										<div className="col-md-12">{this.props.filter}</div>
									</div>
								</div>
								<div className="box-body">
									<div className="row">
										<div className="col-md-12">{this.props.dataGrid}</div>
									</div>
								</div>
							</Item>
							<Item title={'Cadastro'}>
								<div className="box-body">
									<div className="row">
										<div className="col-md-12">{this.props.form}</div>
									</div>
								</div>
							</Item>
						</TabPanel>
					</div>
				</BaseForm>
			</React.Fragment>
		);
	}
}
